import React from 'react';

import './PlanetAnimation.css'

const Planet = props => {
    return (
        <div id="wrapper">
            <div class="zzz1"></div>
            <div class="zzz2"></div>
            <div class="zzz3"></div>
            <div class="planet"> 
            <div class="face">
                <div class="eye">
                <div class="eye-in"></div>
            </div>
            <div class="mouth"></div>
            <div class="eye">
                <div class="eye-in"></div>
            </div>
            </div>
            </div>
            <div class="star pos-star1 "></div>
            {/* <div class="star pos-star2 "></div> */}
            <div class="star pos-star3 "></div>
        </div>
    )
}

export default Planet;